import React, { useState, useEffect } from 'react';
import Text from 'components/Core/Text';
import Button from 'components/Core/Button';
import { CareersCultureSection } from './styles';

const CareersCulture = ({ cultureGroups, culturePrograms, ...otherProps }) => {
  const [groupsHovered, setIsGroupsHovered] = useState(false);
  const [programsHovered, setIsProgramsHovered] = useState(false);
  const [width, setWidth] = useState(null);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('load', handleResize);
    window.addEventListener('resize', handleResize);
  });

  return (
    <CareersCultureSection {...otherProps}>
      <Text
        type={'h2'}
        alignDesktop={'center'}
        size={'28px'}
        className="careers--underlined-heading"
        id="titanculture"
      >
        Employee Resource Groups
      </Text>
      <div className="careers--culture-row">
        <div
          className="careers--culture-item"
          style={{
            backgroundImage: 'url(' + cultureGroups + ')',
            backgroundColor: groupsHovered === true ? `rgba(25, 55, 79, 0.8))` : 'none',
          }}
          onMouseOver={() => setIsGroupsHovered(true)}
          onMouseOut={() => setIsGroupsHovered(false)}
        >
          <div className="careers--culture-overlay">
            <Text
              type={'h5'}
              alignDesktop={'left'}
              size={'28px'}
              className="careers--culture-heading"
            >
              Groups
            </Text>
            <ul
              className="careers--culture-list"
              style={{
                display: width <= 576 ? 'block' : groupsHovered === true ? 'block' : 'none',
              }}
            >
              <li>APac (American Pacific American Charter)</li>
              <li>BarevTitans (Our Armenian Group)</li>
              <li>BlackTitans</li>
              <li>JewishTitans</li>
              <li>Los Titans (LatinX Charter)</li>
              <li>Titan Family (Parents)</li>
              <li>Titan Pride Alliance (LGBTQ+)</li>
              <li>Womxn of ServiceTitan</li>
              <li>Yallah Titans</li>
            </ul>
          </div>
        </div>
        <div
          className="careers--culture-item"
          style={{
            backgroundImage: 'url(' + culturePrograms + ')',
            backgroundColor: groupsHovered === true ? `rgba(25, 55, 79, 0.8))` : 'none',
          }}
          onMouseOver={() => setIsProgramsHovered(true)}
          onMouseOut={() => setIsProgramsHovered(false)}
        >
          <div className="careers--culture-overlay">
            <Text
              type={'h5'}
              alignDesktop={'left'}
              size={'28px'}
              className="careers--culture-heading"
            >
              Programs
            </Text>
            <ul
              className="careers--culture-list"
              style={{
                display: width <= 576 ? 'block' : programsHovered === true ? 'block' : 'none',
              }}
            >
              <li>Professional development and community</li>
              <li>
                Classes encouraging Titans to take a break, dance, move, cook, etc. during COVID-19
                WFH
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Button className="careers--culture--button" type={'secondary'} to={'/job-openings'}>
        Job Openings
      </Button>
    </CareersCultureSection>
  );
};

export default CareersCulture;
